import renderer from "_src/engine/renderer";
import { colorUtils } from "_src/utils";
import { getPngImageFromPixels } from "_src/client/utils";
import renderGraph from "_src/render_graph/render_graph";

const DEBUG = false;

export default function (graph, width, height) {

  const scene = graph.getWorkspaceScene();
  const AAScene = graph.getPass(renderGraph.ANTIALIASING).getMainScene();

  const oldWidth = scene.camera.viewport[2];
  const oldHeight = scene.camera.viewport[3];

  setRenderingSize(scene, AAScene, width, height);

  renderer.renderScene(scene, true);

  const promise = AAScene.getBufferPixels().then((pixels) => {

    colorUtils.flipImageBufferVertically(pixels, width, height);

    if (DEBUG) {
      // this will download an image
      getPngImageFromPixels(pixels, width, height);
    }

    return pixels;
  });

  renderer.renderScene(AAScene, true);

  setRenderingSize(scene, AAScene, oldWidth, oldHeight);

  return promise;

}

function setRenderingSize(scene, AAScene, width, height) {
  const fb = scene.getFramebuffer();
  fb.resize(width, height)
  const AAFb = AAScene.getFramebuffer();
  AAFb.resize(width, height)
  scene.camera.setViewport(width, height);
  AAScene.camera.setViewport(width, height);
}